import React from "react";
import Fade from "react-reveal/Fade";

const Aws = () => {
  return (
    <div className="container aws">
    <Fade>
    <h1>Behöver du hjälp med AWS?</h1>
    </Fade>
    <Fade bottom delay={300}>
        <>
          <p>Vi vill hjälpa start-ups att komma igång med AWS, så lätt och snabbt som möjligt.</p>
          <p>Hör av er och boka ett möte med oss.</p>
          <p>Kontakta oss på <a href="mailto:kontakta@stik.nu">kontakta@stik.nu</a> så hjälper vi dig!</p>
        </>
    </Fade>
    </div>
  );
};

export default Aws;
